/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { ColumnManager } from '../manager/table-manager/column-manager';

export class ResizingStateBox {
  get id(): string {
    return this.column.property.id;
  }
  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
    this.column.headerWidth = value;
  }
  public column: ColumnManager;
  public px: number;
  public x: number;
  private _width: number;

  public constructor(column: ColumnManager) {
    this.column = column;
    this._width = this.column.width;
    this.x = 0;
  }

  public fix() {
    this.column.specificWidth = this.column.headerWidth;
    this.column.width = this.column.headerWidth;
    this.column.property.specificWidth = this.column.headerWidth;
  }
}
